import { statsData } from '@/mocks/home';

export default function Stats() {
  return (
    <section className="relative -mt-12 z-20 w-full px-4 md:px-6" aria-label="数据统计">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {statsData.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-lg p-5 md:p-6 text-center border border-background-200/70"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center text-primary-500">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}